/**
 * CortisolPriorityCard — едно действие за днес, по модела на BHI и DHI.
 * Данни: GET /api/cortisol/priority
 */
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Target, CheckCircle2, ArrowRight } from "lucide-react";
import { useAuth } from "@/App";

export default function CortisolPriorityCard({ isDark = false, onGoTo, refreshKey = 0 }) {
  const { API } = useAuth();
  const [d, setD] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/cortisol/priority`);
      setD(data);
    } catch { setD(null); }
  }, [API]);

  useEffect(() => { load(); }, [load, refreshKey]);
  if (!d) return null;

  const accent = d.done ? "#10B981" : d.urgency === "high" ? "#F97316" : "#F59E0B";

  return (
    <div className={`rounded-2xl border p-4 mb-4 ${isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200"}`}
      style={{ borderLeft: `4px solid ${accent}` }}
      data-testid="cortisol-priority-card">
      <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider"
        style={{ color: accent }}>
        {d.done ? <CheckCircle2 className="w-3.5 h-3.5" /> : <Target className="w-3.5 h-3.5" />}
        Действие за днес
      </div>
      <div className="text-sm font-extrabold mt-1" data-testid="cortisol-priority-title">
        {d.action_bg}
      </div>
      <div className="text-[11px] opacity-75 mt-0.5">{d.why_bg}</div>
      <div className="flex items-center justify-between gap-2 mt-2 flex-wrap">
        <span className="text-[10px] opacity-60">{d.title_bg}</span>
        <button onClick={() => onGoTo?.(d.tab)}
          className="text-[11px] font-bold inline-flex items-center gap-1"
          style={{ color: accent }}
          data-testid="cortisol-priority-cta">
          {d.cta_bg} <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
